import React, { ReactNode, useEffect, useRef } from 'react';
import classes from './styles.module.scss';
import Desktop from './desktop';
import { RiEditBoxLine } from 'react-icons/ri';
import { IoCreate } from 'react-icons/io5';
import { FaShareAlt } from 'react-icons/fa';
import Hls from 'hls.js';
import analytics from '../../../Assets/landing/analytics.svg';
import wishlist from '../../../Assets/landing/wishlist.svg';
import catalogue from '../../../Assets/landing/catalogue.svg';
import SEOHeader from '../../../components/SEO';

export type LandingPageData = {
  showcase?: {
    primary: string;
    secondary: string;
    showcase_img: string;
  };
  becomevendor?: {
    label: string;
    sub: string;
    video: string;
    steps: {
      path: string;
      icon: ReactNode;
      label: string;
      text: string;
    }[];
  };
  whyus?: {
    label: string;
    sub: string;
    list: { name: string; body: string; icon: any }[];
  };
  contact?: {
    label: string;
    sub: string;
    contacts: string[];
  };
  faqs?: {
    label: string;
    faq: {
      title: string;
      content: string;
    }[];
  };
};

const Landing = () => {
  const videoRef = useRef<any>(null);
  let fileHostBase = 'https://res.cloudinary.com/dgi5c3klp/video/upload/';

  // this is a mock up object it just gives the structure the landing ppage should have
  const landing_page_data: LandingPageData = {
    showcase: {
      primary: 'Create. Publish. Grow.',
      secondary:
        'Create your business profile, showcase your services, and connect with clients instantly.',
      showcase_img:
        'https://res.cloudinary.com/dgi5c3klp/image/upload/v1744193885/bazaarcheap/live/web-assets/landing_page_image_complete_b0ral4.png',
    },
    becomevendor: {
      label: 'Create Your Business Page',
      sub: 'Create your business profile, showcase your services, and connect with clients instantly.',
      video:
        fileHostBase +
        'v1744193959/bazaarcheap/live/web-assets/becomevendor.mp4',
      steps: [
        {
          path: '/signup',
          icon: <RiEditBoxLine className={classes.icon_data} />,
          label: 'Create Your Account',
          text: 'Open a free account to begin building your presence and access your dashboard.',
        },
        {
          path: '/dashboard/create-store',
          icon: <IoCreate className={classes.icon_data} />,
          label: 'Add What You Offer',
          text: 'List your products or services with images and details your clients can browse.',
        },
        {
          path: '/dashboard/store#share',
          icon: <FaShareAlt className={classes.icon_data} />,
          label: 'Share Your Link',
          text: 'Post or send your page link on social, chat or email to attract enquiries.',
        },
      ],
    },
    whyus: {
      label: 'Why Bazaarcheap?',
      sub: 'We help businesses and professionals build a credible online presence. Here`s how:',
      list: [
           {
          icon: catalogue,
          name: 'Professional Online Presence',
          body: 'Publish a modern page highlighting your products or services under one shareable link.',
        },

        {
          icon: analytics,
          name: 'Dashboard',
          body: 'Manage your requests, track client interactions, and stay on top of your business.',
        },
        // {
        //   icon: catalogue,
        //   name: 'Share Anywhere',
        //   body: 'Send your link on social, WhatsApp or email so clients can view and enquire.',
        // },
        // {
        //   icon: wishlist,
        //   name: 'Simple, Fast, Free',
        //   body: 'Set up in minutes. No checkout flows—just visibility, credibility and growth.',
        // },
        {
          icon: wishlist,
          name: 'Orders & Requests',
          body: 'Clients can add items or services to a cart and send you a request.',
        },
      ],
    },
    contact: {
      label: 'Contact Us',
      sub: 'Questions or need support? Reach out—our team will help you set up.',
      contacts: ['support@bazaarcheap.com', '+256 784 331 902'],
    },
    faqs: {
      label: 'FAQS',
      faq: [
        {
          title: 'Reset Account Password',
          content:
            'Sed ut perspiciatis, unde omnis iste natus error sit voluptatem accusantium doloremque laudantium, totam rem Eaque ipsa, quae ab illo inventore veritatis et quasi architecto beatae vitae dicta sunt, explicabo. Nemo enim ipsam voluptatem, quia voluptas sit, aspernatur aut odit aut fugit,  Eed quia consequuntur magni dolores eos, qui ratione voluptatem sequi nesciunt, neque porro quisquam est, qui dolorem ipsum, quia dolor sit amet consectetur adipisci velit, sed quia non numquam eius modi Tempora inci[di]dunt, ut labore et dolore magnam aliquam quaerat voluptatem. Ut enim ad minima veniam, quis laboriosam, nisi ut aliquid ex ea commodi consequatur? [D]Quis autem vel eum i[r]ure reprehenderit, qui in ea voluptate velit esse, ',
        },
        {
          title: 'Reset Account Password',
          content:
            'Sed ut perspiciatis, unde omnis iste natus error sit voluptatem accusantium doloremque laudantium, totam rem Eaque ipsa, quae ab illo inventore veritatis et quasi architecto beatae vitae dicta sunt, explicabo. Nemo enim ipsam voluptatem, quia voluptas sit, aspernatur aut odit aut fugit,  Eed quia consequuntur magni dolores eos, qui ratione voluptatem sequi nesciunt, neque porro quisquam est, qui dolorem ipsum, quia dolor sit amet consectetur adipisci velit, sed quia non numquam eius modi Tempora inci[di]dunt, ut labore et dolore magnam aliquam quaerat voluptatem. Ut enim ad minima veniam, quis laboriosam, nisi ut aliquid ex ea commodi consequatur? [D]Quis autem vel eum i[r]ure reprehenderit, qui in ea voluptate velit esse, ',
        },
        {
          title: 'Reset Account Password',
          content:
            'Sed ut perspiciatis, unde omnis iste natus error sit voluptatem accusantium doloremque laudantium, totam rem Eaque ipsa, quae ab illo inventore veritatis et quasi architecto beatae vitae dicta sunt, explicabo. Nemo enim ipsam voluptatem, quia voluptas sit, aspernatur aut odit aut fugit,  Eed quia consequuntur magni dolores eos, qui ratione voluptatem sequi nesciunt, neque porro quisquam est, qui dolorem ipsum, quia dolor sit amet consectetur adipisci velit, sed quia non numquam eius modi Tempora inci[di]dunt, ut labore et dolore magnam aliquam quaerat voluptatem. Ut enim ad minima veniam, quis laboriosam, nisi ut aliquid ex ea commodi consequatur? [D]Quis autem vel eum i[r]ure reprehenderit, qui in ea voluptate velit esse, ',
        },
        {
          title: 'Reset Account Password',
          content:
            'Sed ut perspiciatis, unde omnis iste natus error sit voluptatem accusantium doloremque laudantium, totam rem Eaque ipsa, quae ab illo inventore veritatis et quasi architecto beatae vitae dicta sunt, explicabo. Nemo enim ipsam voluptatem, quia voluptas sit, aspernatur aut odit aut fugit,  Eed quia consequuntur magni dolores eos, qui ratione voluptatem sequi nesciunt, neque porro quisquam est, qui dolorem ipsum, quia dolor sit amet consectetur adipisci velit, sed quia non numquam eius modi Tempora inci[di]dunt, ut labore et dolore magnam aliquam quaerat voluptatem. Ut enim ad minima veniam, quis laboriosam, nisi ut aliquid ex ea commodi consequatur? [D]Quis autem vel eum i[r]ure reprehenderit, qui in ea voluptate velit esse, ',
        },
      ],
    },
  };

  useEffect(() => {
    const video = videoRef.current;
    const hls = new Hls({
      debug: true,
      enableWorker: true,
      lowLatencyMode: true,
      backBufferLength: 90,
    });
    const url = landing_page_data.becomevendor!.video;

    if (Hls.isSupported()) {
      hls.loadSource(url);
      hls.attachMedia(video);
      hls.on(Hls.Events.ERROR, (err, data) => {
        console.log(err);
        console.warn('error data', data);
      });
      hls.on(Hls.Events.MANIFEST_PARSED, function () {
        video.play();
      });
    } else {
      console.log('hls not supported');
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <>
      <SEOHeader />
      <Desktop data={landing_page_data} video={videoRef} />
    </>
  );
};

export default Landing;